const hint_svg = (
  <svg height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.76 69.34">
    <path
      style={{
        fill: "none",
        stroke: "#36349a",
        strokeMiterlimit: 10,
        strokeWidth: 4
      }}
      d="M60.39,2.49H12.28c-5.33,0-9.65,5-9.65,11.18V37C2.63,43.2,7,48.2,12.28,48.2H41.91L54,65l6.49-16.81C65.78,48.12,70,43.15,70,37V13.67C70,7.5,65.72,2.49,60.39,2.49Z"
    />
    <path
      style={{ fill: "#36349a" }}
      d="M34.44,41.47A3.29,3.29,0,0,1,37.74,38a3.23,3.23,0,0,1,3.31,3.48,3.31,3.31,0,1,1-6.61,0Zm1.4-8L35.05,6.58h5.38l-.78,26.88Z"
    />
  </svg>
);

export default hint_svg;
